/**
 * dateHelpers — V2.N.8 (factorisation)
 *
 * Helpers de formatage de date partagés par les pages admin.
 * Remplace les copies de relTime/absTime dans chaque page.
 */

/** Temps relatif court depuis un ISO (ex: "5 min", "3 h", "2 j"). */
export function relTime(iso: string): string {
  const m = Math.round((Date.now() - new Date(iso).getTime()) / 60000);
  if (m < 1) return "à l'instant";
  if (m < 60) return `${m} min`;
  const h = Math.round(m / 60);
  if (h < 24) return `${h} h`;
  return `${Math.round(h / 24)} j`;
}

/** Date absolue localisée FR. */
export function absTime(iso: string): string {
  try {
    return new Date(iso).toLocaleString('fr-FR');
  } catch {
    return iso;
  }
}
